import { SVGProps } from 'react';

export const DoubleArrowToRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.35984 1.98483C2.50628 1.83839 2.74372 1.83839 2.89017 1.98483L6.64017 5.73484C6.78661 5.88128 6.78661 6.11872 6.64017 6.26516L2.89017 10.0152C2.74372 10.1616 2.50628 10.1616 2.35983 10.0152C2.21339 9.86872 2.21339 9.63128 2.35983 9.48483L5.84467 6L2.35984 2.51517C2.21339 2.36872 2.21339 2.13128 2.35984 1.98483ZM5.35984 1.98483C5.50628 1.83839 5.74372 1.83839 5.89017 1.98483L9.64017 5.73484C9.78661 5.88128 9.78661 6.11872 9.64017 6.26516L5.89017 10.0152C5.74372 10.1616 5.50628 10.1616 5.35984 10.0152C5.21339 9.86872 5.21339 9.63128 5.35984 9.48483L8.84467 6L5.35984 2.51517C5.21339 2.36872 5.21339 2.13128 5.35984 1.98483Z'
    />
  </svg>
);
